import { render, staticRenderFns } from "./TrainingDetail.vue?vue&type=template&id=521c786c&scoped=true"
import script from "./TrainingDetail.vue?vue&type=script&lang=js"
export * from "./TrainingDetail.vue?vue&type=script&lang=js"
import style0 from "./TrainingDetail.vue?vue&type=style&index=0&id=521c786c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c786c",
  null
  
)

export default component.exports